import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["backdrop", "panel"]
  static values = {
    open: Boolean,
    persist: { type: Boolean, default: false }
  }

  connect() {
    if (!this.element.id) {
      console.error("Dialog must have an ID:", this.element);
      return;
    }
    const overlayContainer = document.getElementById("dialogs");
    const existingDialog = overlayContainer.querySelector(`#${this.element.id}`);
    if (existingDialog) {
      return;
    }
    overlayContainer.appendChild(this.element);
  }

  open() {
    this.openValue = true;
  }

  close() {
    this.openValue = false;
  }

  openValueChanged(value) {
    if (value) {
      this.#applyOpen();
    } else {
      this.#applyClose();
    }
  }

  #applyOpen() {
    document.body.classList.add("overflow-hidden");
  }

  #applyClose() {
    document.body.classList.remove("overflow-hidden");
    this.#closeAllSubmenus();
  }

  #closeAllSubmenus() {
    const submenus = this.element.querySelectorAll('[data-controller~="submenu"]');
    submenus.forEach(submenu => {
      submenu.dataset.submenuOpenValue = "false";
    });
  }
}

window.addEventListener("turbo:before-render", preserveDialog);

function preserveDialog(event) {
  const newDialogs = event.detail.newBody.querySelectorAll('[data-controller~="dialog"]')
  const previousDialogs = Array.from(document.querySelectorAll('[data-controller~="dialog"]'))

  newDialogs.forEach(nd => {
    if (nd.dataset.dialogPersistValue === "true") {
      const pd = previousDialogs.find(d => d.id === nd.id)
      if (!pd) return

      if (pd.dataset.dialogOpenValue != null) {
        nd.dataset.dialogOpenValue = pd.dataset.dialogOpenValue
      }
    }
  })
}

